module.exports = __webpack_public_path__ + "media/images/dogs_images/cavador.jpg";